import type { IFieldDefinition, IRecordTypeDefinition } from '@platform/core/types';

/**
 * Поле виду запису (прототип v4: вид елемента бізнес-аналізу — «Зацікавлена сторона», «Вимога»… — замість назви типу в шапці й крихтах):
 * поле вибору, від якого залежить показ інших полів (`visibleWhen.field`); без таких умов — undefined. Чиста функція.
 */
export function kindFieldOf(rt: Pick<IRecordTypeDefinition, 'fields'>): IFieldDefinition | undefined {
  const key = rt.fields.find((f) => f.visibleWhen)?.visibleWhen?.field;
  return key ? rt.fields.find((f) => f.key === key && f.type === 'select') : undefined;
}
